import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import UIkit from 'uikit'

// Settings
import settings from 'settings'

// Utils
import analytics from 'app/views/utils/analytics'
import { Button } from '@hackedu/react-components'


class WwwNav extends React.Component {
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      if (UIkit.offcanvas('#nav-www').isToggled()) {
        UIkit.offcanvas('#nav-www').hide()
      }
    }
  }

  render() {
    return (
      <div data-uk-sticky="sel-target: .uk-navbar-container; cls-active: uk-navbar-sticky uk-box-shadow-small; bottom: #transparent-sticky-navbar">
        <nav className="uk-navbar-container uk-background-default" data-uk-navbar="dropbar: true; align: center; boundary-align: true; delay-hide: 0;">
          <div className="uk-navbar-left">
            {(this.props.location.pathname === '/demo') ? (
              <a className="uk-navbar-item uk-logo uk-navbar-toggle" href={settings.urls.www}>
                <img src="/static/images/logo.png" style={{ maxWidth: 129 }} alt="Logo" />
              </a>
            )
              : null}
          </div>
          <div className="uk-navbar-right">
            {(this.props.location.pathname === '/demo') ? (
              <ul className="uk-navbar-nav  uk-visible@m">
                <li>
                  <a
                    href={`${settings.urls.www}/contact`}
                    onClick={() => { analytics.track('click-navi-contact') }}
                  >
                    Contact
                  </a>
                </li>
                <li>
                  <a
                    href={`${settings.urls.www}/secure-development-training`}
                    onClick={() => { analytics.track('click-navi-learn-more') }}
                  >
                    <Button
                      content="Learn More"
                      primary
                      extraClassName="tm-button-primary"
                    />
                  </a>
                </li>
              </ul>
            ) : null}

            <button
              type="button"
              className="uk-navbar-toggle uk-hidden@m uk-navbar-toggle-icon uk-icon uk-navbar-right"
              data-uk-navbar-toggle-icon=""
              data-uk-toggle="target: #nav-www"
            />
            <div
              id="nav-www"
              data-uk-offcanvas="mode: push; overlay: true"
              className="uk-offcanvas"
            >
              <div className="uk-offcanvas-bar" style={{ maxWidth: 250 }}>
                <button className="uk-offcanvas-close" type="button" data-uk-close />
                <div className="uk-panel">
                  <ul className="uk-nav uk-nav-default tm-nav uk-margin-bottom">
                    <li>For Companies</li>
                    <ul className="uk-nav-sub">
                      <li>
                        <a href={`${settings.urls.www}/secure-development-training`} onClick={() => { analytics.track('click-navi-developer-training') }}>Developer Training</a>
                      </li>
                      <li>
                        <Link to="/pci-developer-training" onClick={() => { analytics.track('click-navi-pci-developer-training') }}>PCI Training Package</Link>
                      </li>
                      <li>
                        <Link to="/custom-content" onClick={() => { analytics.track('click-navi-custom-content') }}>Custom Training Content</Link>
                      </li>
                      <li>
                        <Link to="/ctf" onClick={() => { analytics.track('click-navi-ctf') }}>Hosted CTF</Link>
                      </li>
                    </ul>

                    <li>For Hackers</li>
                    <ul className="uk-nav-sub">
                      <li><Link to="/hacktivity" onClick={() => { analytics.track('click-navi-hacktivity') }}>Hacktivity</Link></li>
                      <li><Link to="/vulnerabilities" onClick={() => { analytics.track('click-navi-vulnerabilities') }}>Public Vulnerabilities</Link></li>
                    </ul>
                    <li>
                      <a href={settings.urls.blog} onClick={() => { analytics.track('click-navi-blog') }}>Blog</a>
                    </li>

                    <li className="uk-nav-header">Company</li>
                    <li>
                      <Link to="/about" onClick={() => { analytics.track('click-navi-about') }}>About Us</Link>
                    </li>
                    <li>
                      <Link to="/partners" onClick={() => { analytics.track('click-navi-partners') }}>Partners</Link>
                    </li>
                    <li>
                      <Link to="/careers" onClick={() => { analytics.track('click-navi-careers') }}>Careers</Link>
                    </li>
                    <li>
                      <a href={`${settings.urls.www}/contact`} onClick={() => { analytics.track('click-navi-contact') }}>Contact</a>
                    </li>

                    <li className="uk-nav-header">
                      Account
                    </li>
                    <li>
                      <Link to="/login" onClick={() => { analytics.track('click-navi-login') }}>Login</Link>
                    </li>
                    <li>
                      <Link to="/register" onClick={() => { analytics.track('click-navi-register') }}>Register</Link>
                    </li>
                    <li>
                      <Link to="/demo" onClick={() => { analytics.track('click-navi-demo') }}>
                        <button type="button" className="uk-button uk-button-primary tm-button-primary">Try the Demo</button>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    )
  }
}

export default withRouter(WwwNav)
